import { Component, input, InputSignal } from '@angular/core';
import { AttachmentNamePipe } from '../../../../../pipes/attachment.name.pipe';
import { CommonModule, CurrencyPipe, DatePipe, NgForOf, NgIf } from '@angular/common';
import { LabelComponent } from '../../../../../common/label/label.component';
import { AttachmentAppEntityShipmentRead, ShipmentAppEntityShipmentRead } from '../../../../../openapi';
import { RouterModule } from '@angular/router';
import { UploaderAttachmentsService } from '../../../../../services/uploader-attachments.service';
import { firstValueFrom } from 'rxjs';
import { PaymentCommonService } from '../../../../../services/payment.common.service';

@Component({
  selector: 'app-decision-data-preview',
  standalone: true,
  imports: [
    AttachmentNamePipe,
    CurrencyPipe,
    DatePipe,
    LabelComponent,
    CommonModule,
    RouterModule
  ],
  templateUrl: './decision-data-preview.component.html'
})
export class DecisionDataPreviewComponent {

  public shipments: InputSignal<ShipmentAppEntityShipmentRead[]> = input<ShipmentAppEntityShipmentRead[]>([]);

  public canPay: InputSignal<boolean> = input<boolean>(false);

  constructor(
    private uploaderService: UploaderAttachmentsService,
    private paymentCommonService: PaymentCommonService,
  ) {
  }

  public downloadConfirmation(id: string): void {
    firstValueFrom(this.paymentCommonService.downloadConfirmation(id)).then();
  }

  public getDocuments(v: ShipmentAppEntityShipmentRead): Array<AttachmentAppEntityShipmentRead | undefined> {
    return v?.attachments?.map(v => v?.attachment) || [];
  }

  public onDownloadFile(event: Event, id?: string, name?: string): void {
    event.preventDefault();
    event.stopPropagation();
    if (id) {
      this.uploaderService.downloadAttachment(id, name).toPromise().then();
    }
  }

}
